import { gql } from "@apollo/client";

export const LOCKER_USER_ACCOUNTS = gql`
	query (
		$operatorId: ID!
		$userId: ID
		$userMobile: String
		$gender: [Int]
		$ageFrom: Int
		$ageTo: Int
		$verifiedStatus: Int
		$withApp: Boolean
		$firstName: String
		$lastName: String
		$signupDateFrom: Date
		$signupDateInto: Date
	) {
		lockerUserAccounts(
			operatorId: $operatorId
			userId: $userId
			userMobile: $userMobile
			gender: $gender
			ageFrom: $ageFrom
			ageTo: $ageTo
			verifiedStatus: $verifiedStatus
			withApp: $withApp
			firstName: $firstName
			lastName: $lastName
			signupDateFrom: $signupDateFrom
			signupDateInto: $signupDateInto
		) {
			userAccountId
			userType {
				userType
			}
			user {
				userId
				firstName
				middleName
				lastName
				suffixName
				userMobile
				userEmail
				gender
				verifiedOn
				birthDate
				verifiedStatus
				userStatus
				idNumber
				idType {
					idType
					idTypeId
				}
				createdAt
			}
		}
	}
`;

export const LOCKER_USER_ACCOUNT_PACKAGES = gql`
	query ($operatorId: ID!, $userId: ID) {
		lockerUserAccounts(operatorId: $operatorId, userId: $userId) {
			packages {
				packageId
				transactionId
				partnerAgentMobile
				senderMobile
				recipientMobile
				packageDate
				waybillNumber
				packageStateNo
				pickupByDate
				senderName
				lockerLocation
				locker {
					lockerId
					lockerName
				}
			}
		}
	}
`;

export const PARTNERS_FOR_LOCKER_USER_ACCOUNTS = gql`
	query ($operatorId: ID!) {
		partners(operatorId: $operatorId) {
			partnerId
			companyNickname
		}
	}
`;
export const BRANCHES_FROM_LOCKER_USER_ACCOUNTS = gql`
	query ($operatorId: ID!, $partnerId: ID) {
		partnerBranches(operatorId: $operatorId, partnerId: $partnerId) {
			partnerBranchId
			partnerBranch
		}
	}
`;

export const UPDATE_USERS = gql`
	mutation ($users: [UpdateUserObject]) {
		updateUsers(users: $users) {
			user {
				userId
			}
		}
	}
`;

export const USER_STATUS_HISTORY = gql`
	query ($userId: ID!) {
		userStatusHistory(userId: $userId) {
			userStatusHistoryId
			userId
			verifiedStatus
			userStatus
			verifiedStatusComments
			userStatusComments
			createdAt
		}
	}
`;
export const SAVE_USER_STATUS_HISTORY = gql`
	mutation ($userStatusHistoryArgs: SaveUserStatusHistoryObject!) {
		saveUserStatusHistory(userStatusHistoryArgs: $userStatusHistoryArgs) {
			userStatusHistory {
				userStatusHistoryId
			}
		}
	}
`;

export const UPDATE_USER_STATUS = gql`
	mutation ($user: UpdateUserStatusObject!) {
		updateUserStatus(users: $user) {
			user {
				userId
				verifiedStatus
				userStatus
			}
		}
	}
`;
